"use strict";
var routes = {
    '/': 'Home',
    '/projects': 'Projects',
    '/about': 'About'
};
module.exports = routes;
